import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { OverlayModule } from '@angular/cdk/overlay';
import { CoreUiButtonsModule } from '../../buttons/core-ui-buttons.module';
import { CoreUIIconsModule } from '../core-ui-icons.module';
import { CoreUIDropdownMenuItemDirective } from './core-ui-dropdown-menu-item.directive';
import { CoreUIDropdownMenuComponent } from './core-ui-dropdown-menu.component';

@NgModule({
  declarations: [CoreUIDropdownMenuComponent, CoreUIDropdownMenuItemDirective],
  imports: [CommonModule, OverlayModule, CoreUIIconsModule, CoreUiButtonsModule],
  exports: [CoreUIDropdownMenuComponent, CoreUIDropdownMenuItemDirective],
})
export class CoreUIDropdownMenuModule {}
